(($) => {

  $(document).ready(() => {
    const stickyHeader = () => {
      const scroll = $(document).scrollTop()

      if (scroll >= 300) {
        $('body').addClass('sticky')
      } else {
        $('body').removeClass('sticky')
      }
    };
    stickyHeader()

    $(document).on('scroll', stickyHeader)
  })

})(jQuery)
